import { useSuspenseQuery } from "@apollo/client/react";

import {
  GetProductDocument,
  type GetProductQuery,
  type GetProductQueryVariables,
} from "~/features/admin/products/gqls";

export function useProductDetail(productId: string) {
  return useSuspenseQuery<GetProductQuery, GetProductQueryVariables>(GetProductDocument, {
    variables: { id: productId },
  });
}
